import React from 'react';
import * as Styles from './BannerPlan.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import { IconAiPencil2 } from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';

const BannerPlan = ({ trialAvailable }) => {
  const { studioPlans: studioPlansLocale } = useLocale();

  return (
    <Styles.Banner hasTrial={trialAvailable}>
      <Styles.WrapperTitleStudio>
        <Styles.TitleStudio>{studioPlansLocale.studio}</Styles.TitleStudio>
        <IconAiPencil2 color="highPure" />
      </Styles.WrapperTitleStudio>
      <Styles.Title hasTrial={trialAvailable}>
        {trialAvailable
          ? studioPlansLocale.bannerPlans.titleTrial
          : studioPlansLocale.bannerPlans.title
        }
      </Styles.Title>

      {trialAvailable && (
        <Styles.Subtitle>{studioPlansLocale.bannerPlans.subtitle}</Styles.Subtitle>
      )}
    </Styles.Banner>
  );
};

export default withErrorBoundary(BannerPlan, 'BannerPlan');
